export default "__VITE_ASSET__DhXaPydb__"